import { render } from "./DirectorFAQ.vue?vue&type=template&id=eaadebe4&scoped=true"
import script from "./DirectorFAQ.vue?vue&type=script&lang=js"
export * from "./DirectorFAQ.vue?vue&type=script&lang=js"

import "./DirectorFAQ.vue?vue&type=style&index=0&id=eaadebe4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaadebe4"]])

export default __exports__